// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"a0c887b1","425":"415e4e9d","658":"ebee701f","727":"58a0cf40","836":"23c385ec","917":"81b9e9fe","964":"03bcc44f"}[chunkId] + ".css";
};